<div class="ion-padding" *ngIf="communications.count() == 0">
  <ion-note>No communications to show</ion-note>
</div>

<div *ngIf="communications.count() > 0">
  <app-communication-item
    *ngFor="let communication of communications"
    [communication]="communication"
    (click)="onCommunicationView(communication)"
  >
  </app-communication-item>

  <salonmonster-load-mask
    *ngIf="isLoadingCommunications"
  ></salonmonster-load-mask>

  <smr-tap-retry
    *ngIf="errorOccurredWhileLoadingCommunicationHistory"
    (click)="loadCommunications()"
  ></smr-tap-retry>

  <ion-infinite-scroll
    (ionInfinite)="loadCommunications($event)"
    [disabled]="communicationsFullyLoaded"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</div>
